module.exports = __webpack_public_path__ + "resources/d0ca5136df4e523818e139423571bfb0.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/vp-variable.png
// module id = 231
// module chunks = 0